var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.07012 20.5589H3.36939V8.6413H7.07012V20.5589ZM5.21752 7.01566C4.03431 7.01566 3.07422 6.03517 3.07422 4.85195C3.07422 4.28351 3.30003 3.73836 3.70198 3.33641C4.10393 2.93446 4.64908 2.70865 5.21752 2.70865C5.78596 2.70865 6.33112 2.93446 6.73307 3.33641C7.13502 3.73836 7.36083 4.28351 7.36083 4.85195C7.36083 6.03517 6.40074 7.01566 5.21752 7.01566ZM20.9206 20.5589H17.2282V14.7576C17.2282 13.3748 17.2001 11.6019 15.3042 11.6019C13.3802 11.6019 13.085 13.1039 13.085 14.6581V20.5589H9.3881V8.6413H12.9371V10.267H12.9888C13.4828 9.33045 14.6896 8.34231 16.49 8.34231C20.2353 8.34231 20.9238 10.8088 20.9238 14.0123V20.5589H20.9206Z","fill":"currentColor"}));
}

SocialLinkedin.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
